import Cookies from 'universal-cookie';
import { sendToLoginPage } from '../../utils/externalFunc';

export default function disconnect(locationIdent) {
  const cookies = new Cookies();
  cookies.remove('ymt_stk', { path: '/' });
  sendToLoginPage(locationIdent)
}